
import LoginForm from './LoginForm.vue';
import vwLogo from '../../assets/vw-logo.svg';
import seatLogo from '../../assets/seat-logo.svg';
import audiLogo from '../../assets/audi-logo.svg';
import cupraLogo from '../../assets/cupra-logo.svg';

const DEVICE_HORIZONTAL_PADDING = {
  mobile: '36px',
  tablet: '82px',
  desktop: '100px',
};

const BRAND_LOGOS = {
  volkswagen: vwLogo,
  seat: seatLogo,
  audi: audiLogo,
  cupra: cupraLogo,
};

const LOGOS_WIDTH = {
  volkswagen: '48px',
  seat: '200px',
  audi: '120px',
  cupra: '200px',
};

export default {
  components: { LoginForm },

  data() {
    return {
      BRAND_LOGOS,
      LOGOS_WIDTH,
      DEVICE_HORIZONTAL_PADDING,
    };
  },

  computed: {
    brandName() {
      return process.env.VUE_APP_BRAND.charAt(0).toUpperCase() + process.env.VUE_APP_BRAND.slice(1);
    },

    getBrandLogo() {
      return BRAND_LOGOS[process.env.VUE_APP_BRAND];
    },

    getBrandLogoWidth() {
      return LOGOS_WIDTH[process.env.VUE_APP_BRAND];
    },

    getHorizontalPadding() {
      if (this.$q.screen.xs) {
        return DEVICE_HORIZONTAL_PADDING.mobile;
      }

      if (this.$q.screen.sm || this.$q.screen.md) {
        return DEVICE_HORIZONTAL_PADDING.tablet;
      }

      return DEVICE_HORIZONTAL_PADDING.desktop;
    },
  },
};
